<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="图片上传"
        width="800px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="specialInspectsBind"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
          <div>
            <div v-if="!specialInspectsBind.attachments || !specialInspectsBind.attachments.length">暂无附件</div>
            <table width="100%">
              <tr v-for="(item, index) in specialInspectsBind.attachments" :key="index">
                <td>附件{{index + 1}}</td>
                <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">{{item.fileName}}</td>
                <td style="padding:5px"><el-input v-model="item.note" size="mini"/></td>
                <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
              </tr>
            </table>
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                :disabled="uploadLoading"
                style="display: inline-block; float: right; margin: 5px;">
              <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  export default {
    name:"BindPictureEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        dialogVisible1: false,
        contentLoading: false,
        uploadLoading: false,
        submitLoading: false,
        dialogImageUrl: "",
        disabled: false,
        fileList: [],
        index: 0,
        specialInspectsBind: {
          pkid: 0,
          attachments: [],
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(row,index) {
        console.log(index);
        this.specialInspectsBind = row;
        this.dialogVisible = true;
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.specialInspectsBind.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      deleteFile(index) {
        this.specialInspectsBind.attachments.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "https://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      save() {
        console.log(this.specialInspectsBind);
        this.dialogVisible=false;
        this.$emit("add-picture",this.specialInspectsBind,this.index);
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
